import { HttpClient } from '@angular/common/http';
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private renderer: Renderer2;
  private themeLinkElement!: HTMLLinkElement;
  private currentTheme = 'light';
  // Keep palettes in a getter to vary the code shape (behavior unchanged)
  private get chartPalettes(): { [key: string]: string[] } {
    return {
      light: ['#5e9cd3', '#ed7d31', '#70ad47', '#ffc000', '#4472c4', '#a5a5a5'],
      dark: ['#4bacc6', '#f79646', '#9bbb59', '#c0504d', '#772c77', '#5f5f5f'],
      contrast: ['#ff5722', '#9c27b0', '#2196f3', '#4caf50', '#ffeb3b', '#795548'],
    };
  }
  constructor(
    private rendererFactory: RendererFactory2,
    private http: HttpClient,
  ) {
    this.initRenderer();
    this.initThemeLinkElement();
  }

  private initRenderer() {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  private initThemeLinkElement() {
    this.themeLinkElement = this.renderer.createElement('link');
    this.themeLinkElement.rel = 'stylesheet';
    this.themeLinkElement.id = 'theme-link';
    this.renderer.appendChild(document.head, this.themeLinkElement);
  }

  setTheme(theme: string) {
    const themeUrl = `assets/themes/${theme}-theme.css`;
    this.themeLinkElement.href = themeUrl;
  }
  getCurrentTheme(): string {
    return this.currentTheme;
  }

  isDarkTheme(): boolean {
    return this.currentTheme.includes('dark');
  }

  getChartPalette(count: number): string[] {
    const palette = this.chartPalettes[this.currentTheme] || this.chartPalettes.light;
    return this.buildPalette(palette, count);
  }

  private buildPalette(baseColors: string[], count: number): string[] {
    return Array.from({ length: Math.max(0, count) }, (_, i) => baseColors[i % baseColors.length]);
  }
}
